import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-292">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-294">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6 text-center" data-id="element-295">
            El problema no es tu fe. Es tu estado interior.
          </h2>

          <div className="prose prose-lg max-w-none mb-8" data-id="element-296">
            <p className="text-dark/80 leading-relaxed mb-4" data-id="element-297">
              Cuando tu mente está entrenada en escasez, culpa o miedo, orar se
              vuelve un desahogo, no una alineación. Y desde ese estado, es muy
              difícil recibir con paz, decidir con claridad y actuar con
              constancia.
            </p>
            <p className="text-dark/80 leading-relaxed mb-6" data-id="element-298">
              <strong data-id="element-299">"30 Días con Dios, Orden, Provisión y Abundancia"</strong>{' '}
              es un plan diario que te ayuda a:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-300">
            <div className="flex items-start gap-3 p-4 bg-cream rounded-lg" data-id="element-301">
              <span className="text-gold text-xl" data-id="element-302">•</span>
              <p className="text-dark/80" data-id="element-303">
                Calmar el ruido interno para que tu oración produzca paz real
              </p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-cream rounded-lg" data-id="element-304">
              <span className="text-gold text-xl" data-id="element-305">•</span>
              <p className="text-dark/80" data-id="element-306">
                Renovar tu mente con verdad bíblica y hábitos simples
              </p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-cream rounded-lg" data-id="element-307">
              <span className="text-gold text-xl" data-id="element-308">•</span>
              <p className="text-dark/80" data-id="element-309">
                Crear un sistema de fe + acción que funcione en 10–15 min/día
              </p>
            </div>
            <div className="flex items-start gap-3 p-4 bg-cream rounded-lg" data-id="element-310">
              <span className="text-gold text-xl" data-id="element-311">•</span>
              <p className="text-dark/80" data-id="element-312">
                Relacionarte con el dinero y la provisión desde mayordomía y
                gratitud, no desde miedo
              </p>
            </div>
          </div>

          <h3 className="text-2xl font-serif font-bold text-navy mb-6 text-center" data-id="element-313">
            Qué cambia
          </h3>

          <div className="overflow-x-auto" data-id="element-314">
            <table className="w-full border-collapse" data-id="element-315">
              <thead data-id="element-316">
                <tr className="bg-navy text-white" data-id="element-317">
                  <th className="p-4 text-left font-semibold" data-id="element-318">🔴 Antes</th>
                  <th className="p-4 text-left font-semibold" data-id="element-319">🟢 Después</th>
                </tr>
              </thead>
              <tbody data-id="element-320">
                <tr className="border-b border-gray-200" data-id="element-321">
                  <td className="p-4 bg-red-50" data-id="element-322">
                    Oras desde la carencia y el afán
                  </td>
                  <td className="p-4 bg-green-50" data-id="element-323">
                    Oras desde la fe, la gratitud y la paz
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-324">
                  <td className="p-4 bg-red-50" data-id="element-325">Tu mente no para</td>
                  <td className="p-4 bg-green-50" data-id="element-326">
                    Tienes una rutina que ordena tu interior
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-327">
                  <td className="p-4 bg-red-50" data-id="element-328">
                    Ansiedad constante por el dinero
                  </td>
                  <td className="p-4 bg-green-50" data-id="element-329">
                    Claridad para administrar y avanzar con paz
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-330">
                  <td className="p-4 bg-red-50" data-id="element-331">
                    Empiezas con fervor y abandonas
                  </td>
                  <td className="p-4 bg-green-50" data-id="element-332">
                    Constancia real con pasos pequeños y obedientes
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-333">
                  <td className="p-4 bg-red-50" data-id="element-334">
                    Te sientes solo(a) en el proceso
                  </td>
                  <td className="p-4 bg-green-50" data-id="element-335">
                    Caminas con Dios día a día, paso a paso
                  </td>
                </tr>
                <tr data-id="element-336">
                  <td className="p-4 bg-red-50" data-id="element-337">
                    Culpa y sensación de "algo falla en mí"
                  </td>
                  <td className="p-4 bg-green-50" data-id="element-338">
                    Gracia, dignidad e identidad firme como hijo(a) de Dios
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}